import { whatsNew_Card_NonPremiumTravelUpsell_Dropdown } from 'owa-locstrings/lib/strings/whatsnew_card_nonpremiumtravelupsell_dropdown.locstring.json';
import {
    whatsNew_Card_NonPremiumTravelUpsell_Button,
    whatsNew_Card_NonPremiumDomainConnectUpsell_Body,
    whatsNew_Card_NonPremiumDomainConnectUpsell_Dropdown,
    whatsNew_Card_NonPremiumDomainConnectUpsell_Tooltip,
    whatsNew_Card_NonPremiumDomainConnectUpsell_Title,
} from '../../strings.locstring.json';
import loc, { format } from 'owa-localize';
import * as React from 'react';
import { observer } from 'mobx-react-lite';

import { logWhatsNewCardShown, logWhatsNewCardButtonClicked } from '../../utils/logDatapoint';
import { logUsage } from 'owa-analytics';
import { WhatsNewCardIdentity } from '../../store/schema/WhatsNewCardIdentity';
import { Link } from 'office-ui-fabric-react/lib/Link';

import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { ControlIcons } from 'owa-control-icons';
import { WhatsNewCardProperty } from '../../store/schema/WhatsNewCardProperty';
import { getExperienceTypeForUser, PremiumExperienceType } from 'owa-premium-travel';

const styles = require('../WhatsNewFluentCard.scss');
const upsellUrlFormat =
    'https://go.microsoft.com/fwlink/?linkid=2005900&WT.mc_id=PROD_OL-Web_InApp_WhatsNew_DomainUpgrade&ep={0}';

function onUpgradeClicked(evt: React.MouseEvent<unknown>): void {
    evt.stopPropagation();
    logWhatsNewCardButtonClicked(WhatsNewCardIdentity.NonPremiumTravelUpsellExp);
    window.open(
        format(upsellUrlFormat, getUserConfiguration().SessionSettings.EncryptedUserPuid),
        '_blank'
    );
}

function onLearnMoreClicked(evt: React.MouseEvent<unknown>): void {
    evt.stopPropagation();
    logUsage('whatsNewNonPremiumDomainConnectUpsellExpLearnMore');
    window.open('https://go.microsoft.com/fwlink/?linkid=871933');
}

export const NonPremiumDomainConnectUpsellExp = observer(
    function NonPremiumDomainConnectUpsellExp(props: {}) {
        React.useEffect(() => {
            logWhatsNewCardShown(WhatsNewCardIdentity.NonPremiumDomainConnectUpsellExp);
        }, []);

        return (
            <div>
                <div>{loc(whatsNew_Card_NonPremiumDomainConnectUpsell_Body)}</div>
                <div>
                    {loc(whatsNew_Card_NonPremiumDomainConnectUpsell_Dropdown)}
                    <span>
                        <TooltipHost
                            content={loc(whatsNew_Card_NonPremiumDomainConnectUpsell_Tooltip)}>
                            <Icon iconName={ControlIcons.Info} />
                        </TooltipHost>
                    </span>
                    <div>
                        <div>
                            <Link
                                className={styles.whatsNewCardCallToAction}
                                onClick={onLearnMoreClicked}>
                                {loc(whatsNew_Card_NonPremiumTravelUpsell_Dropdown)}
                            </Link>
                        </div>
                        <div>
                            <Link
                                className={styles.whatsNewCardCallToAction}
                                onClick={onUpgradeClicked}>
                                {loc(whatsNew_Card_NonPremiumTravelUpsell_Button)}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
);

function nonPremiumDomainConnectUpsellExp(): WhatsNewCardProperty {
    return {
        identity: WhatsNewCardIdentity.NonPremiumDomainConnectUpsellExp,
        title: loc(whatsNew_Card_NonPremiumDomainConnectUpsell_Title),
        iconName: ControlIcons.Info,
        body: <NonPremiumDomainConnectUpsellExp />,
        isHidden: async () => {
            var userExperienceType = await getExperienceTypeForUser();
            return userExperienceType !== PremiumExperienceType.NonPremiumDomainConnectUpsell;
        },
    };
}

export default nonPremiumDomainConnectUpsellExp;
